// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `   .span{
   color: #605f5f;
    font-family: 'Roboto';
    font-weight: 700;

   }
   .spanF{
    color: #808080;
font-family: Roboto;
font-size: 11px;
font-style: normal;
font-weight: 400;
line-height: normal;
    }
  .spanService{
    color:#538dff;
    font-family: 'Roboto';
        font-size: 20px;
  }
  .sessioncircle{
    color:#fcfcfc;
    background-color: #538dff;
    font-family: 'Roboto';
        font-size: 24px;
    align-items: center;
    font-weight: bold;
    border-radius: 50%; /* Rounded background */
    width: 50px;
    height: 50px;
  }

  .title{
    font-size: 16px;
    color: rgb(31, 31, 31);
    font-weight: bold;
    font-family: 'Roboto';
  }
  .subtitle{
    color: #AAA;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .hover:hover{
    cursor: pointer;
    background-color:#f7e8d0
    ;
  }

  .edit {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    margin-top: 20px;
    border-radius: 25px;
    color: white;
    font-size: 18px;
    font-weight: bold;
    text-transform: uppercase;
    border: none;
  }
  
  .edit:hover {
    
    cursor: pointer;
  }
  
  .arrow {
    position: absolute;
    right: 20px;
    font-size: 24px;
    transition: transform 0.2s;
  }
  
  .edit:hover .arrow {
    transform: translateY(10px);
  }
  
  .edit::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 50%;
    background-color: #b5d5ff;
    transform: scale(0);
    transition: transform 0.2s;}
    `, "",{"version":3,"sources":["webpack://./src/Calendar/scheduler/bookingDetails/style.css"],"names":[],"mappings":"GAAG;GACA,cAAc;IACb,qBAAqB;IACrB,gBAAgB;;GAEjB;GACA;IACC,cAAc;AAClB,mBAAmB;AACnB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;IACf;EACF;IACE,aAAa;IACb,qBAAqB;QACjB,eAAe;EACrB;EACA;IACE,aAAa;IACb,yBAAyB;IACzB,qBAAqB;QACjB,eAAe;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB,EAAE,uBAAuB;IAC3C,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf;IACA;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;EACd;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,0BAA0B,CAAC","sourcesContent":["   .span{\n   color: #605f5f;\n    font-family: 'Roboto';\n    font-weight: 700;\n\n   }\n   .spanF{\n    color: #808080;\nfont-family: Roboto;\nfont-size: 11px;\nfont-style: normal;\nfont-weight: 400;\nline-height: normal;\n    }\n  .spanService{\n    color:#538dff;\n    font-family: 'Roboto';\n        font-size: 20px;\n  }\n  .sessioncircle{\n    color:#fcfcfc;\n    background-color: #538dff;\n    font-family: 'Roboto';\n        font-size: 24px;\n    align-items: center;\n    font-weight: bold;\n    border-radius: 50%; /* Rounded background */\n    width: 50px;\n    height: 50px;\n  }\n\n  .title{\n    font-size: 16px;\n    color: rgb(31, 31, 31);\n    font-weight: bold;\n    font-family: 'Roboto';\n  }\n  .subtitle{\n    color: #AAA;\n    font-family: Roboto;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n  .hover:hover{\n    cursor: pointer;\n    background-color:#f7e8d0\n    ;\n  }\n\n  .edit {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    margin-top: 20px;\n    border-radius: 25px;\n    color: white;\n    font-size: 18px;\n    font-weight: bold;\n    text-transform: uppercase;\n    border: none;\n  }\n  \n  .edit:hover {\n    \n    cursor: pointer;\n  }\n  \n  .arrow {\n    position: absolute;\n    right: 20px;\n    font-size: 24px;\n    transition: transform 0.2s;\n  }\n  \n  .edit:hover .arrow {\n    transform: translateY(10px);\n  }\n  \n  .edit::before {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    border-radius: 50%;\n    background-color: #b5d5ff;\n    transform: scale(0);\n    transition: transform 0.2s;}\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
